/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardUserDto
 */
export interface LeaderboardUserDto {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardUserDto
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardUserDto
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardUserDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardUserDto
     */
    fullName: string;
}

export function LeaderboardUserDtoFromJSON(json: any): LeaderboardUserDto {
    return LeaderboardUserDtoFromJSONTyped(json, false);
}

export function LeaderboardUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'position': json['position'],
        'id': json['id'],
        'fullName': json['fullName'],
    };
}

export function LeaderboardUserDtoToJSON(value?: LeaderboardUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'position': value.position,
        'id': value.id,
        'fullName': value.fullName,
    };
}

